<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      事業者に対する機能利用権限の設定画面(STFMFM02C31)                                                                          _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="1" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                >メインページ</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'STDSDC02C01' }"
                >事業者情報</router-link
              >
            </li>
            <li>
              <span class="current">事業者機能利用権限(電帳法)の設定</span>
            </li>
          </ul>
        </div>
        <h1 class="h1">事業者機能利用権限(電帳法)の設定</h1>
        <!--
        ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <h2 class="h2">
          {{ data.businessOperatorCode + "_" + data.businessOperatorName }}
        </h2>
        <p class="lead">
          事業者に対し、電子取引やスキャナ保存が必要な書類の登録を依頼、共有する場合は［電帳法オプションの機能利用権限］を［許可］に設定します。<br />
          ［電帳法オプションの機能利用権限］を［拒否］から［許可］に変更した場合、［確定］ボタンクリック後、事業者に電帳法オプションの機能利用のURLを通知します。
        </p>
        <!-- ******************************************************************
               *  事業者に対する機能利用権限の設定                                          *
               ****************************************************************** -->
        <div class="para">
          <br />
          <div class="criteria">
            <div class="frm-row p-5">
              <span class="frm-label frm-size-l"
                >電帳法オプションの機能利用権限</span
              >
              <ToggleButton
                ref="refUsageRightsSetting"
                style="width: 240px"
                class="frm-toggle frm-size-l ml-200px"
                v-model="data.usageRights"
                :list="radioList"
              />
            </div>
          </div>
        </div>
      </div>
          <!-- ******************************************************************
           *  下部ボタン群                                                  *
           ****************************************************************** -->
      <div class="frm-btn-row footer-btn">
        <div class="frm-item grow center">
          <button
            class="frm-btn strong large"
            type="button"
            @click="handleConfirm"
            ref="refConfirm"
          >
            確定
          </button>
          <button class="frm-btn large" type="button" @click="handleCancel">
            <!-- <button
            class="frm-btn large"
            type="button"
            @click="$redirect({ name: 'STDSDC02C01' })"
          > -->
            キャンセル
          </button>
        </div>
      </div>
    </div>

    <!-- No5事業者機能利用権限(電帳法)の追加対応 start-->
    <STFMFM02C30SentMailtNotificationContentModal :isProcessShow="data.STFMFM02C30Modle.isProcessShow"
      :businessOperatorId="data.STFMFM02C30Modle.businessOperatorId"
      :accountingOfficeName="data.STFMFM02C30Modle.accountingOfficeName"
      :businessOperatorName="data.STFMFM02C30Modle.businessOperatorName" 
      :mailAddress="data.STFMFM02C30Modle.mailAddress"
      @cancelSend="cancelSend"></STFMFM02C30SentMailtNotificationContentModal>
    <!-- No5事業者機能利用権限(電帳法)の追加対応 end-->
    <!-- ******************************************************************
           *  ページトップ移動アイコン設定                                 *
    ******************************************************************-->
    <ScrollToTop></ScrollToTop>
  </div>
  <ConfirmDialog
    :isShow="showConfirmDialog"
    :message="message"
    @confirm="dialogConfirm"
    @cancel="dialogCancel"
  ></ConfirmDialog>
</template>

<!-- ********************************
         *******  スクリプト定義  *******
         ******************************** -->

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import _lodash from "lodash";
import Common from "@/util/common.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import ScrollToTop from "@/components/ScrollToTop.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { API_BopDataUnlock } from "@/api/Modules/CM04/STDSCM04C00.js";
import STFMFM02C30SentMailtNotificationContentModal from "@/components/STFMFM02C30SentMailtNotificationContentModal.vue";
import {
  API_STFMFM02C31_Initialize,
  API_STFMFM02C31_UpdateFunctionAuthority,
} from "@/api/Modules/FM02/STFMFM02C31.js";
// No5事業者機能利用権限(電帳法) start
import {
  API_STFMFM02C01_GetMailAddress,
} from "@/api/Modules/FM02/STFMFM02C01.js";
// No5事業者機能利用権限(電帳法) end

//#region 変数定義
// 共有変数
const store = useStore();
const router = useRouter();

//画面データ
const data = reactive({
  businessOperatorId: 0, //事業者こID
  businessOperatorCode: "", //事業者コード
  businessOperatorName: "", //事業者名
  functionAuthorityKeyName: "", //機能権限キー名
  usageRights: 0, //機能利用権限設定
  STFMFM02C30Modle: {
    isProcessShow: false,
    businessOperatorId: 0,
    accountingOfficeName: "",
    businessOperatorName: "",
    mailAddress: "",
  }
});

//機能利用権限設定の初期値保存
const usageRights_backUp = ref(0);

//機能利用権限設定活性制御
const refUsageRightsSetting = ref(null);

//確認ダイアログ 画面
const message = ref(Common.getMessage("MTCL2001", []));
const showConfirmDialog = ref(false);

//　利用権限設定 list
const radioList = [
  { code: 0, text: "許可" },
  { code: 1, text: "拒否" },
];

//エラーメッセージ
const errors = ref([]);
//#endregion

//#region 画面初期化
// 初期フォーカス設定
const initFocus = () => {
  refUsageRightsSetting.value.focus();
};

// 画面データを取得
const viewInit = () => {
  store.commit("businessModule/processDialogue", true);
  let params = {
    businessOperatorId: data.businessOperatorId,
    businessOperatorCode: data.businessOperatorCode,
    businessOperatorName: data.businessOperatorName,
    functionAuthorityKeyName: data.functionAuthorityKeyName,
  };
  return API_STFMFM02C31_Initialize(params)
    .then((response) => {
      if (_lodash.eq(response.result, "0000")) {
        data.functionAuthorityKeyName = response.functionAuthorityKeyName;
        data.usageRights = response.usageRights
          ? radioList[0].code
          : radioList[1].code;
        usageRights_backUp.value = data.usageRights;
      }
      //上記以外の場合
      else {
        errors.value = [];
        if (response.errorCD) {
          // if (response.errorCD == "MTCL1036") {
          // } else {
          // エラー表示
          errors.value.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
          // }
        }
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      store.commit("businessModule/processDialogue", false);
    });
};

//遷移元から取得
const dataInit = (flg) => {
  data.businessOperatorId = $cookies.get("businessOperatorId"); //事業者こID
  data.businessOperatorCode = $cookies.get("businessOperatorCode"); //事業者コード
  data.businessOperatorName = $cookies.get("businessOperatorName"); //事業者名
  data.accountingOfficeName = $cookies.get("accountingOfficeName"); //税理士事務所名
  if (flg) data.usageRights = usageRights_backUp.value;
};
// No5事業者機能利用権限(電帳法)の追加対応ーURLの通知Modalキャンセル 
const cancelSend = (isReturn) => {
  data.STFMFM02C30Modle.isProcessShow = false
  if (isReturn) {
      // 事業者情報画面(STDSDC02C01)に遷移する
      router.push({ name: "STDSDC02C01" });
  }
};

//画面遷移前
onBeforeRouteLeave(async (to, from, next) => {
  // 画面遷移チェック
  if (!$cookies.get("SessionID") || to.name == "STDSCM04C06") {
    next();
  } else {
    //事業者ユーザ情報のロック解除
    let result = await unlockFunctionAuthority();
    // 事業者情報画面(STDSDC02C01)に遷移する
    if (result) next();
  }
});

//画面初期化設定
onMounted(async () => {
  // 初期フォーカス設定
  initFocus();

  // 遷移元から取得
  dataInit();

  // 画面データを取得
  await viewInit();
});
//#endregion

//#region ボタン処理

//
const sentMail = () => {
  errors.value = [];
  store.commit("businessModule/processDialogue", true);
  let params = {
    businessOperatorId: data.businessOperatorId,
  };
  return API_STFMFM02C01_GetMailAddress(params)
    .then((response) => {
      if (_lodash.eq(response.result, "0000")) {
        
        //宛先
        var mailAddress = "";
        if (response.stfmfM02C01BopDataHeaders[0].addressList != null) {
          for (var item of response.stfmfM02C01BopDataHeaders[0].addressList) {
            mailAddress += item;
            mailAddress += "\n";
          }
        }
        // STFMFM02C30画面表示
        data.STFMFM02C30Modle = {
        isProcessShow: true,
        businessOperatorId: $cookies.get("businessOperatorId"),
        accountingOfficeName: $cookies.get("accountingOfficeName"),
        businessOperatorName: $cookies.get("businessOperatorName"),
        mailAddress: mailAddress,
      };
        // STFMFM02C30画面表示
        data.STFMFM02C30Modle.isProcessShow = true
      }
      //上記以外の場合
      else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
    })
    .catch((error) => {
      console.log(error);
      return false;
    })
    .finally(() => {
      store.commit("businessModule/processDialogue", false);
    });
};
//機能利用権限設定
const updateFunctionAuthority = () => {
  store.commit("businessModule/processDialogue", true);
  let params = {
    businessOperatorId: data.businessOperatorId,
    businessOperatorCode: data.businessOperatorCode,
    businessOperatorName: data.businessOperatorName,
    functionAuthorityKeyName: data.functionAuthorityKeyName,
    usageRights: data.usageRights == radioList[0].code ? true : false,
  };
  return API_STFMFM02C31_UpdateFunctionAuthority(params)
    .then((response) => {
      if (_lodash.eq(response.result, "0000")) {
        return true;
      }
      //上記以外の場合
      else {
        errors.value = [];
        if (response.errorCD) {
          // if (response.errorCD == "MTCL1036") {
          // } else {
          // エラー表示
          errors.value.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
          // }
        }
        return false;
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    })
    .finally(() => {
      store.commit("businessModule/processDialogue", false);
    });
};

//ロック解除
const unlockFunctionAuthority = () => {
  store.commit("businessModule/processDialogue", true);
  let params = {
    businessOperatorId: data.businessOperatorId,
  };
  return API_BopDataUnlock(params)
    .then((response) => {
      if (response.errorCD) {
        this.errors = [];
        this.errors.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
        return false;
      }
      return true;
    })
    .catch((error) => {
      console.log(error);
      return false;
    })
    .finally(() => {
      store.commit("businessModule/processDialogue", false);
    });
};

// 確定ボタンをクリックする
const handleConfirm = async () => {
  let result = true;
  result = await updateFunctionAuthority();
  //URL通知
  if (result && data.usageRights==0) {
    sentMail()
  } else {
      // 事業者情報画面(STDSDC02C01)に遷移する
      if (result) router.push({ name: "STDSDC02C01" });
  }

};
// キャンセルボタンをクリックする
const handleCancel = async () => {
  //入力中の各データを破棄する。
  dataInit(true);
  // 事業者情報画面(STDSDC02C01)に遷移する
  router.push({ name: "STDSDC02C01" });
  // }
};
//#endregion

//#region 確認ダイアログ 画面
// 確認ボタンをクリックする
const dialogConfirm = async () => {
  //入力中の各データを破棄する。
  dataInit(true);

  // 事業者情報画面(STDSDC02C01)に遷移する
  router.push({ name: "STDSDC02C01" });
};

// キャンセルボタンをクリックする
const dialogCancel = () => {
  showConfirmDialog.value = false;
};
//#endregion
</script>
<style scoped>
.inner p:empty + .h2 {
  margin-top: 0px;
}
.inner p:not(empty) + .h2 {
  margin-top: 30px;
}
</style>
